import { render, staticRenderFns } from "./activity-item.vue?vue&type=template&id=6fa3f232"
import script from "./activity-item.vue?vue&type=script&lang=js"
export * from "./activity-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports